import { namespace } from './store';
import { createSelector } from 'reselect';
import { RedactionCodesState } from './models';

export const selectStore = (state: { [namespace]: RedactionCodesState }) =>
  state[namespace];

export const selectIsDrawerOpen = createSelector(
  selectStore,
  (s) => s.isDrawerOpen
);

/** Everything the fetch returned, deleted codes included. */
export const selectAllRedactionCodeRecords = createSelector(
  selectStore,
  (s) => s.redactionCodes
);

/**
 * The codes a user may see and choose — the settings table and every picker.
 *
 * `!== true` rather than `=== false`: codes written before VE-28768 carry no
 * `isDeleted` at all, and those are live.
 */
export const selectRedactionCodes = createSelector(
  selectAllRedactionCodeRecords,
  (codes) =>
    Object.fromEntries(
      Object.entries(codes).filter(([, code]) => code.isDeleted !== true)
    )
);

/** The deleted view. */
export const selectDeletedRedactionCodes = createSelector(
  selectAllRedactionCodeRecords,
  (codes) =>
    Object.fromEntries(
      Object.entries(codes).filter(([, code]) => code.isDeleted === true)
    )
);

export const selectIsFetchingCodes = createSelector(
  selectStore,
  (s) => s.isFetchingCodes
);

export const selectSelectedEditCode = createSelector(
  selectStore,
  (s) => s.selectedRedactionCode
);

export const selectLimit = createSelector(selectStore, (s) => s.limit);
export const selectOffset = createSelector(selectStore, (s) => s.offset);
export const selectCountRedactionCodes = createSelector(
  selectStore,
  (s) => s.countRedactionCodes
);
